var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showViewer)?_c('image-viewer',{attrs:{"z-index":9999,"initial-index":_vm.firstOne,"on-close":_vm.closeViewer,"url-list":_vm.urlList}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }